define('modules/form_editor/collections/fields',['require','exports','module','backbone','../models/form_element_factory','lib/util'],function (require, exports, module) {
  'use strict';
  var Backbone = require('backbone'),
    FormElementFactory = require('../models/form_element_factory'),
    util = require('lib/util');

  var Serialization = {
    fromJSON: function (json) {
      var elements = new module.exports();
      elements.reset(_.map(json, FormElementFactory.fromJSON));
      return elements;
    },
  };

  var Controller = {
    addField: function (name, attrs, opts) {
      var index = this.where({ name: name }).length,
        labelText = attrs.labelText + ' ' + (index ? index : ''),
        elementId = 'ID' + util.generateRandom(),
        creationAttrs = {
          labelText: labelText.trim(),
          elementId: elementId.trim(),
          nameAttr: null,
          items: attrs.items || [],
        },
        newField = FormElementFactory.createElement(name, creationAttrs);

      //set rest of attributes
      newField.set(_.omit(attrs, 'labelText', 'elementId', 'items'));
      this.add(newField, opts);
      if (opts.at !== undefined) this.trigger('sort');

      return newField;
    },
    moveUp: function (model) {
      if (!this.contains(model)) {
        return;
      }
      var refIndex = this.indexOf(model) - 1;
      // keep social login as first field
      if (!this.hasSocialLogin() || refIndex) {
        this.remove(model, { silent: true });
        this.add(model, { at: refIndex, silent: true });
        this.trigger('sort');
      }
    },
    moveDown: function (model) {
      if (!this.contains(model)) {
        return;
      }
      var refIndex = this.indexOf(model) + 1;
      this.remove(model, { silent: true });
      this.add(model, { at: refIndex, silent: true });
      this.trigger('sort');
    },
    duplicate: function (model) {
      if (!this.contains(model)) {
        return;
      }
      var refIndex = this.indexOf(model) + 1;
      var newModel = model.clone();
      this.add(newModel, { at: refIndex, silent: true });
      this.trigger('sort');
      return newModel;
    },
  };

  module.exports = Backbone.Collection.extend(
    {
      areThereOtherItemWithThisAtributteName: function (value, elementId, field) {
        return (
          this.filter(function (element) {
            return element.get('elementId') != elementId && element.get(field) == value;
          }).length != 0
        );
      },
      hasSocialLogin: function () {
        return !!this.getSocialLoginOrder();
      },
      getSocialLoginOrder: function () {
        var loginElements = this.getSocialElements();
        return loginElements.length;
      },
      getSocialElements: function (name) {
        name = name || '';
        return this.filter(function (element) {
          return !!~element.name.indexOf('custom:login:' + name);
        });
      },
      hasGoogleReCaptcha: function () {
        return !!this.getFormCaptcha('google_recaptcha').length;
      },
      getFormCaptcha: function (service) {
        service || (service = '');
        return this.filter(function (element) {
          return !!~element.name.indexOf('custom:captcha:' + service);
        });
      },
    },
    {
      fromJSON: Serialization.fromJSON,
    }
  );

  _.extend(module.exports.prototype, Controller);
});

